import { render } from "./Authorised.vue?vue&type=template&id=0540c614&scoped=true"
import script from "./Authorised.vue?vue&type=script&lang=js"
export * from "./Authorised.vue?vue&type=script&lang=js"

import "./Authorised.vue?vue&type=style&index=0&id=0540c614&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0540c614"]])

export default __exports__